import * as React from 'react';
import { CopyableField } from '@css-xp/base';
import { BillingDocWithLineItems, Invoice } from '@atlassian/cssxp-types-billing';

const InvoicePdfLinkPane = (billingDoc: BillingDocWithLineItems) => {
  const invoice = billingDoc as Invoice;

  return (
    <>
      <h3>Get invoice PDF link</h3>

      <div data-testid="pdf-link-markup">
        <CopyableField
          autoSelect={true}
          value={`[${invoice.id}|${invoice.pdfLink}]`}
          label="Includes Jira markup e.g. [link title|http://example.com]"
          testId="copy-field-with-jira-markup"
        />
      </div>

      <br />

      <div data-testid="pdf-link-basic">
        <CopyableField
          autoSelect={false}
          value={`${invoice.pdfLink}`}
          label="Basic link"
          testId="copy-field-basic-link"
        />
      </div>
    </>
  );
};

export default InvoicePdfLinkPane;
